import SvgIcon from '@mui/material/SvgIcon';

import type { SvgIconProps } from '@mui/material';

export const ArrowIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 28 36">
        <svg fill="none" height="36" width="28" xmlns="http://www.w3.org/2000/svg"><path d="M10.95 36V11.371l.4-2.447-.85-.306-1.25 2.09L4 16.062l-4-4.079L11.75 0h4.5L28 11.983l-4 4.08-5.25-5.355-1.25-2.09-.85.306.4 2.447V36h-6.1Z" fill="#00B579" /></svg>
    </SvgIcon>
);
